var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "q-edit-content" },
    [
      _vm.value.ext.edit
        ? _c(
            "vh-select",
            {
              model: {
                value: _vm.value.detail.format,
                callback: function ($$v) {
                  _vm.$set(_vm.value.detail, "format", $$v)
                },
                expression: "value.detail.format",
              },
            },
            _vm._l(_vm.formats, function (item) {
              return _c("vh-option", {
                key: item.value,
                attrs: { label: item.label, value: item.value },
              })
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.value.ext.edit && _vm.value.detail.format === "Y-m-d"
        ? _c("vh-date-picker", {
            ref: "dataRef",
            attrs: {
              disabled: _vm.isReplay,
              "value-format": "yyyy-MM-dd",
              placeholder: _vm.$t("form.form_1046"),
              size: "small",
              "picker-options": _vm.pickerOptions,
            },
            on: { focus: _vm.focus },
            nativeOn: {
              click: function ($event) {
                return _vm.Inputfocus.apply(null, arguments)
              },
            },
            model: {
              value: _vm.val,
              callback: function ($$v) {
                _vm.val = $$v
              },
              expression: "val",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.value.ext.edit && _vm.value.detail.format === "H:i:s"
        ? _c("vh-time-picker", {
            attrs: {
              disabled: _vm.isReplay,
              "value-format": "HH:mm:ss",
              placeholder: _vm.$t("form.form_1048"),
              size: "small",
            },
            on: { focus: _vm.focus },
            model: {
              value: _vm.val,
              callback: function ($$v) {
                _vm.val = $$v
              },
              expression: "val",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.value.ext.edit && _vm.value.detail.format === "Y-m-d H:i:s"
        ? _c("vh-date-picker", {
            attrs: {
              type: "datetime",
              disabled: _vm.isReplay,
              "value-format": "yyyy-MM-dd HH:mm:ss",
              placeholder: _vm.$t("form.form_1047"),
              size: "small",
            },
            on: { focus: _vm.focus },
            model: {
              value: _vm.val,
              callback: function ($$v) {
                _vm.val = $$v
              },
              expression: "val",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.value.ext.edit && _vm.errorTip
        ? _c("div", { staticClass: "error-msg" }, [
            _vm._v("\n    " + _vm._s(_vm.errorTip) + "\n  "),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }